import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicRichText } from '@prismicio/react';
import StatHeader from '@/components/aboutUs/StatHeader';

/**
 * Props for `StatGrid`.
 */
export type StatGridProps = SliceComponentProps<Content.StatGridSlice>;

/**
 * Component for "StatGrid" Slices.
 */
const StatGrid = ({ slice }: StatGridProps): JSX.Element => {
  const {
    primary: { stats },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundColor: '#F3F3F8',
      }}
    >
      <div className="container-mx-auto px-5 md:px-0 py-4 text-white h-full flex text-center justify-start">
        <div className="flex flex-row flex-nowrap overflow-x-auto no-scrollbar justify-start gap-x-12 mx-auto py-8">
          {stats.map((item, index) => (
            <div
              className="flex flex-col items-start gap-y-2 max-w-[10rem] min-w-[10rem] mx-auto text-start"
              key={`stat-${index}`}
            >
              <div
                className="flex flex-row gap-x-2 text-black"
                style={{
                  fontWeight: '700',
                  fontSize: '36px',
                }}
              >
                {/* A Custom Component to stylize the + and % characters with the proper color */}
                <StatHeader field={item.value} />
              </div>
              <div
                className="text-black"
                style={{
                  fontSize: '14px',
                  lineHeight: '150%',
                  fontWeight: '700',
                }}
              >
                <PrismicRichText field={item.description} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatGrid;
